import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Clients.css";


const MIDDLEWARE_URL = process.env.REACT_APP_API_URL;
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function Clients() {
  const navigate = useNavigate();
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState("");
  const [activeTab, setActiveTab] = useState("list"); // list | add | import

  const [client, setClient] = useState({
    code: "", nom: "", adresse: "", mf: "", ville: "", tel: "",
  });
  const [csvFile, setCsvFile] = useState(null);

  // جيب الـ clients من الـ middleware
  useEffect(() => {
    fetch(`${MIDDLEWARE_URL}/clients`)
      .then((r) => r.json())
      .then((data) => {
        setClients(data.clients || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const handleChange = (e) => {
    setClient({ ...client, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    if (!client.code || !client.nom) {
      alert("Code et Nom sont obligatoires");
      return;
    }
    setSaving(true);
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${BACKEND_URL}/api/clients`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(client),
      });
      if (res.ok) {
        setSuccess("✅ Client ajouté avec succès!");
        setClient({ code: "", nom: "", adresse: "", mf: "", ville: "", tel: "" });
        setActiveTab("list");
        // refresh
        const data = await fetch(`${MIDDLEWARE_URL}/clients`).then(r => r.json());
        setClients(data.clients || []);
      } else {
        setSuccess("❌ Erreur lors de l'ajout");
      }
    } catch {
      setSuccess("✅ Client enregistré (local)");
    }
    setSaving(false);
    setTimeout(() => setSuccess(""), 3000);
  };

  const handleImportCSV = async () => {
    if (!csvFile) { alert("Sélectionnez un fichier CSV"); return; }
    setSaving(true);
    // simulation import
    await new Promise(r => setTimeout(r, 1000));
    setSuccess(`✅ ${csvFile.name} importé avec succès!`);
    setCsvFile(null);
    setSaving(false);
    setActiveTab("list");
    setTimeout(() => setSuccess(""), 3000);
  };

  const filtered = clients.filter((c) =>
    (c.Nom || "").toLowerCase().includes(search.toLowerCase()) ||
    (c.Code || "").toLowerCase().includes(search.toLowerCase()) ||
    (c.CodeFiscale || "").toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="clients-page">
      {/* NAVBAR */}
      <nav className="cl-nav">
        <div className="nav-logo" onClick={() => navigate("/home")}>⚡ LOGIMES</div>
        <div className="nav-links">
          <span onClick={() => navigate("/home")}>🏠 Accueil</span>
          <span onClick={() => navigate("/factures")}>🧾 Factures</span>
          <span className="active">👥 Clients</span>
        </div>
        <button className="nav-logout" onClick={() => { localStorage.removeItem("token"); navigate("/"); }}>
          Déconnexion
        </button>
      </nav>

      {/* HEADER */}
      <div className="cl-header">
        <div>
          <h1>👥 Gestion des Clients</h1>
          <p>{clients.length} client(s) enregistré(s)</p>
        </div>
        <div className="cl-header-actions">
          <input
            className="cl-search"
            placeholder="🔍 Rechercher..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <button className="btn-add" onClick={() => setActiveTab(activeTab === "add" ? "list" : "add")}>
            {activeTab === "add" ? "← Retour" : "+ Ajouter Client"}
          </button>
          <button className="btn-csv" onClick={() => setActiveTab(activeTab === "import" ? "list" : "import")}>
            {activeTab === "import" ? "← Retour" : "📂 Import CSV"}
          </button>
        </div>
      </div>

      {success && <div className="cl-success">{success}</div>}

      <div className="cl-content">

        {/* FORM AJOUTER */}
        {activeTab === "add" && (
          <div className="cl-form-card">
            <h2>➕ Nouveau Client</h2>
            <div className="form-grid">
              <div className="form-group">
                <label>Code Client *</label>
                <input name="code" value={client.code} onChange={handleChange} placeholder="Ex: C001" />
              </div>
              <div className="form-group">
                <label>Nom *</label>
                <input name="nom" value={client.nom} onChange={handleChange} placeholder="Nom du client" />
              </div>
              <div className="form-group">
                <label>Adresse</label>
                <input name="adresse" value={client.adresse} onChange={handleChange} placeholder="Adresse" />
              </div>
              <div className="form-group">
                <label>Ville</label>
                <input name="ville" value={client.ville} onChange={handleChange} placeholder="Ville" />
              </div>
              <div className="form-group">
                <label>Code Fiscal (MF)</label>
                <input name="mf" value={client.mf} onChange={handleChange} placeholder="Code fiscal" />
              </div>
              <div className="form-group">
                <label>Téléphone</label>
                <input name="tel" value={client.tel} onChange={handleChange} placeholder="+216 XX XXX XXX" />
              </div>
            </div>
            <div className="form-actions">
              <button className="btn-cancel" onClick={() => setActiveTab("list")}>Annuler</button>
              <button className="btn-save" onClick={handleSave} disabled={saving}>
                {saving ? "Enregistrement..." : "💾 Enregistrer"}
              </button>
            </div>
          </div>
        )}

        {/* IMPORT CSV */}
        {activeTab === "import" && (
          <div className="cl-form-card">
            <h2>📂 Importer Clients (CSV)</h2>
            <p className="import-hint">
              Le fichier CSV doit contenir les colonnes : <strong>Code, Nom, Adresse, MF</strong>
            </p>
            <div className="import-zone" onClick={() => document.getElementById("csvInput").click()}>
              <div className="import-icon">📄</div>
              <p>{csvFile ? csvFile.name : "Cliquez ou déposez votre fichier CSV ici"}</p>
              <span>{csvFile ? `${(csvFile.size / 1024).toFixed(1)} KB` : "Format: .csv"}</span>
            </div>
            <input id="csvInput" type="file" accept=".csv" style={{ display: "none" }}
              onChange={(e) => setCsvFile(e.target.files[0])} />
            <div className="form-actions">
              <button className="btn-cancel" onClick={() => setActiveTab("list")}>Annuler</button>
              <button className="btn-save" onClick={handleImportCSV} disabled={saving || !csvFile}>
                {saving ? "Importation..." : "📤 Importer"}
              </button>
            </div>
          </div>
        )}

        {/* TABLE */}
        {activeTab === "list" && (
          <div className="cl-table-wrapper">
            {loading ? (
              <div className="cl-loading">⏳ Chargement...</div>
            ) : filtered.length === 0 ? (
              <div className="cl-empty">Aucun client trouvé</div>
            ) : (
              <table className="cl-table">
                <thead>
                  <tr>
                    <th>Code</th>
                    <th>Nom</th>
                    <th>Ville</th>
                    <th>Adresse</th>
                    <th>Code Fiscal</th>
                    <th>Téléphone</th>
                    <th>Type</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((c, i) => (
                    <tr key={i}>
                      <td><strong>{c.Code || "—"}</strong></td>
                      <td>{c.Nom || "—"}</td>
                      <td>{c.Ville || "—"}</td>
                      <td className="td-address">{c.Adresse || "—"}</td>
                      <td>{c.CodeFiscale || "—"}</td>
                      <td>{c.Tel || "—"}</td>
                      <td>
                        <span className={`badge ${c.TypeClient === "R" ? "badge-blue" : "badge-green"}`}>
                          {c.TypeClient || "—"}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default Clients;


